module.exports = __webpack_public_path__ + "assets/bba6eda956b41ab97e5a9743dc91b05b.png";